<template>
  <div class="col-12 flex flex-wrap py1">
    <div class="col-12 flex flex-column items-center">
      <span class="blue h4n bold center" v-if="order.productName">{{ order.productName }}</span>
      <p class="h4n bold m0 py2 center" v-if="order.description && order.startDate && order.endDate">
        {{ order.description }}, {{ order.startDate }} - {{
          order.endDate }}
      </p>
      <div v-for="(document, index) in order.documents" :key="index" class="col-12 center py1">
        <p class="h4n bold m0 py2 center">{{ document.type }}</p>
        <div v-if="document.reference" class="col-12 flex justify-center">
          <div class="col6">
            <a
              class="h6n underline justify-center pointer"
              :href="download(order.bookingNumber, order.customerId, document.reference, document.type)"
            >{{ getReferencelabel("DOWNLOAD") }}</a>
          </div>
          <!-- <div class="col6 ml2"><a class="h6n underline justify-center disabled " >Partager</a></div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex';

import { getReferencelabel } from '@/mixins/utils';

export default {
  components: {},
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  setup () {
    const store = useStore();

    function download (bookingNumber, customerId, reference, type) {
      let url = `/espacepersonnel/api/download?system_booking_number=${bookingNumber}&system_customer_id=${customerId}&reference=${reference}&modele=${type}`;

      if (store.state.impersonateData) {
        url = `${url}&impersonateData=${encodeURI(store.state.impersonateData)}`;
      }
      return url;
    }

    return { download, getReferencelabel };
  }
};
</script>

<style></style>
